import { Menu, Transition } from '@headlessui/react'
import type { PropsWithChildren } from 'react'
import React, { Fragment } from 'react'
import PlusIcon from '~/components/icons/Plus'

type TransactionMethodProps = {
  title: string
  onSelect?: () => void
}
function TransactionMethod(props: TransactionMethodProps) {
  const { title, onSelect } = props
  return (
    <Menu.Item>
      {({ active }) => (
        <button
          className={`${
            active ? 'bg-brand-purple-200 text-brand-violet-950' : ''
          } group flex w-full items-center gap-2 rounded-md px-2 py-2 text-sm`}
          onClick={onSelect}
        >
          {title}
        </button>
      )}
    </Menu.Item>
  )
}

type AddTransactionMethodProps = PropsWithChildren<{
  title: string
}>
function AddTransaction(props: AddTransactionMethodProps) {
  const { title, children } = props
  return (
    <div className="border-brand-neutral-grey-4 rounded-2xl border border-solid px-[30px] py-5">
      <Menu as="div" className="relative">
        {() => (
          <>
            <Menu.Button className="flex cursor-pointer items-center gap-2">
              <PlusIcon />
              <span className="text-brand-violet-950 text-sm font-medium">{title}</span>
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute z-[50] w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
                <div className="px-1 py-1">{children}</div>
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    </div>
  )
}

AddTransaction.Method = TransactionMethod

export default AddTransaction
